define("ember-changeset-validations/validators/exclusion", ["exports", "ember-changeset-validations/utils/validation-errors", "ember-validators/exclusion"], function (_exports, _validationErrors, _exclusion) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = validateExclusion;
  0; //eaimeta@70e063a35619d71f0,"ember-changeset-validations/utils/validation-errors",0,"ember-validators/exclusion"eaimeta@70e063a35619d71f
  function validateExclusion() {
    let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    if (options.list) {
      options.in = options.list;
    }
    return (key, value) => {
      let result = (0, _exclusion.default)(value, options, null, key);
      return result === true ? true : (0, _validationErrors.default)(key, result);
    };
  }
});